import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedCollection: null,
  collections: [],
  documents: [],
  loading: false,
  uploading: false,
  error: null,
};

const knowledgeBaseSlice = createSlice({
  name: 'knowledgeBase',
  initialState,
  reducers: {
    setSelectedCollection: (state, action) => {
      state.selectedCollection = action.payload;
    },
    setCollections: (state, action) => {
      state.collections = action.payload;
    },
    addCollection: (state, action) => {
      state.collections.push(action.payload);
    },
    removeCollection: (state, action) => {
      state.collections = state.collections.filter(
        (c) => c.name !== action.payload,
      );
      if (state.selectedCollection?.name === action.payload) {
        state.selectedCollection = null;
      }
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    addDocument: (state, action) => {
      state.documents.push(action.payload);
    },
    removeDocument: (state, action) => {
      state.documents = state.documents.filter(
        (d) => d.source !== action.payload,
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUploading: (state, action) => {
      state.uploading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetState: () => initialState,
  },
});

export const {
  setSelectedCollection,
  setCollections,
  addCollection,
  removeCollection,
  setDocuments,
  addDocument,
  removeDocument,
  setLoading,
  setUploading,
  setError,
  resetState,
} = knowledgeBaseSlice.actions;

export default knowledgeBaseSlice.reducer;
